export default __webpack_public_path__ + "static/media/005-mobile payment.70d1b0f9.svg";